import gql from 'graphql-tag';

const onDemandLearnerMaterialsQuery = gql`
  query OnDemandLearnerMaterialsQuery($courseIds: [String!]!) {
    OnDemandLearnerMaterialsV1Resource {
      courses(courseIds: $courseIds) {
        elements {
          id
          summaryCoreProgressPercentage
        }
      }
    }
  }
`;
export default onDemandLearnerMaterialsQuery;
